













import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import ArticleWeekendField from './ArticleWeekendField.vue'

@Component({
  components: {
    ArticleWeekendField
  }
})
class TellimerTodayArticleStep extends Vue {
  name: 'TellimerTodayArticleStep'

  @Prop({ type: Object, required: false })
  draft: any

  @Prop({ type: Boolean, required: false })
  highlightFields: boolean

  @Emit('update')
  update() {
    return { steps: { articles: { article1: this.item } } }
  }

  item: any = {}

  beforeMount() {
    const article = this.draft?.steps?.articles?.article1
    if (article) {
      this.item = {
        ...article
      }
    }
  }
}

export default TellimerTodayArticleStep
